export default __webpack_public_path__ + "static/media/Doctor.ea523cc9.jpg";